import React from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

export interface Material {
  id: string;
  name: string;
  brand: string;
  color: string;
  pricePerKg: number;
}

interface MaterialSelectProps {
  materials: Material[];
  selectedMaterial: Material;
  onMaterialChange: (materialId: string) => void;
}

const MaterialSelect = ({
  materials,
  selectedMaterial,
  onMaterialChange,
}: MaterialSelectProps) => {
  return (
    <Select value={selectedMaterial.id} onValueChange={onMaterialChange}>
      <SelectTrigger className="w-full">
        <SelectValue placeholder="Material auswählen" />
      </SelectTrigger>
      <SelectContent>
        {materials.map((material) => (
          <SelectItem key={material.id} value={material.id}>
            {`${material.brand} ${material.name} ${material.color}`}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default MaterialSelect;